import { render } from "./FlakeAction.vue?vue&type=template&id=6721b05a&scoped=true&ts=true"
import script from "./FlakeAction.vue?vue&type=script&lang=ts"
export * from "./FlakeAction.vue?vue&type=script&lang=ts"

import "./FlakeAction.vue?vue&type=style&index=0&id=6721b05a&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6721b05a"]])

export default __exports__